// PERFORMANCE FIX: This hook now uses Context Provider pattern
// to eliminate query duplication across 64+ components
import { useAuth as useAuthContext } from '../../contexts/AuthContext';
import { UseAuthReturn } from '../../types';

/**
 * Custom hook for managing authentication state and user information
 * NOW USES CONTEXT PROVIDER to eliminate Firestore query duplication
 *
 * PERFORMANCE IMPROVEMENT:
 * - Old: Each component triggered 2-3 Firestore queries (64+ duplicates)
 * - New: Single provider runs queries once, all components get cached results
 *
 * @returns {UseAuthReturn} Complete authentication state and helper functions
 */
export const useAuth = (): UseAuthReturn => {
  // Delegate to the context provider - NO MORE QUERY DUPLICATION
  return useAuthContext();
};

// Default export for flexibility
export default useAuth;
